class CartDrawer extends HTMLElement {
	constructor() {
		super()
		window.FoxTheme = window.FoxTheme || {}
		window.FoxTheme.Cart = this
		this.drawer = this.closest('drawer-component')
		window.FoxTheme.CartDrawer = this.drawer
    this.openWhenAdded = this.dataset.openWhenAdded === 'true'
	}

	connectedCallback() {
    window.FoxThemeEvents.subscribe(`ON_ITEM_ADDED`, async state => {
      const renderState = await this.getRenderableState(state);
      this.renderContents(renderState)
    })
	}

  async getRenderableState(state) {
    if (state && state.sections) return state;

    const sectionIds = [...new Set(this.getSectionsToRender(true).map((section) => section.id))];

    try {
      const url = new URL(window.location.href);
      url.searchParams.set('sections', sectionIds.join(','));

      const response = await fetch(url.toString(), {
        method: 'GET',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      });
      const sections = await response.json();
      return { ...(state || {}), sections };
    } catch (error) {
      console.error(error);
      return state;
    }
  }

  renderContents(parsedState, renderFooter = true) {
    const sections = parsedState && parsedState.sections;
    if (!sections) return;

    this.classList.contains('is-empty') && this.classList.remove('is-empty');
    this.getSectionsToRender(renderFooter).forEach((section) => {
      const sectionHtml = sections[section.id];
      if (!sectionHtml) return;

      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (!sectionElement) return;

      const nextInnerHtml = this.getSectionInnerHTML(sectionHtml, section.selector);
      if (nextInnerHtml === null) return;

      sectionElement.innerHTML = nextInnerHtml;
    });

    setTimeout(() => {
      if (this.openWhenAdded && !this.drawer.isOpen()) {
        this.drawer.openDrawer()
        document.body.classList.add('prevent-scroll')
        window.FoxThemeEvents.emit(`ON_CART_DRAWER_OPEN`, parsedState)
      }
    });

  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return null;

    const sourceDom = new DOMParser().parseFromString(html, 'text/html');
    if (!selector) return sourceDom.body ? sourceDom.body.innerHTML : null;

    const sourceNode = sourceDom.querySelector(selector);
    return sourceNode ? sourceNode.innerHTML : null;
  }

  getSectionsToRender(renderFooter = false) {
    const sections = [
      {
        id: 'cart-drawer',
        selector: '.f-cart-drawer__items',
      },
      {
        id: 'cart-drawer',
        selector: '.cart-drawer__visuals-top',
      },
    ]

    if (renderFooter) {
      sections.push({
        id: 'cart-drawer',
        selector: '.f-drawer__footer',
      })
    }

    return sections
  }

}
customElements.define('cart-drawer', CartDrawer)

class CartDrawerItems extends CartItems {

  initLoading() {
    this.loading = new window.FoxTheme.AnimateLoading(document.querySelector('cart-drawer'), { overlay: document.querySelector('cart-drawer') })
  }
  getSectionsToRender() {
    return [
      {
        id: 'Drawer-Cart',
        section: 'cart-drawer',
        selector: '.f-cart-drawer__items',
      },
      {
        id: 'Drawer-Cart',
        section: 'cart-drawer',
        selector: '.f-cart-drawer__block-subtotal',
      },
      {
        id: 'Drawer-Cart',
        section: 'cart-drawer',
        selector: '.cart-drawer__visuals-top',
      },
      {
        id: 'Drawer-Cart',
        section: 'cart-drawer',
        selector: '.cart-bottom-message-container',
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
